<script setup lang="ts">
    import type { IntroData } from '~/@types/cms';

    export interface IntroProps {
        intro?: IntroData;
        anchor?: string | undefined;
    }
    const props = defineProps<IntroProps>();

    const appStore = useAppStore();
    const subtitle = computed(() => {
        return textLinks(props.intro?.subtitle, appStore.getReference);
    });

    const { setHeader } = useMicroDataStore();
    if (props.intro)
        setHeader({
            name: props.intro.title || '',
            description: removeWoomTextFormat(props.intro.subtitle),
        });
</script>
<template>
    <atm-grid
        v-if="intro"
        class="mol-intro py-8 md:py-10 lg:scroll-mt-32">
        <div
            :id="anchor"
            :class="[{ 'text-center': intro.text_align === 'center' }, 'col-span-2 flex flex-col gap-4 md:col-span-12 lg:col-span-8 lg:col-start-3']">
            <lazy-atm-heading
                v-if="intro.title"
                level="h2"
                size="xl">
                <renderer-html :content="woomTextFormat(intro.title)" />
            </lazy-atm-heading>
            <div
                v-if="subtitle"
                class="link-underline text-lg">
                <renderer-html :content="woomTextFormat(subtitle)" />
            </div>
            <slot></slot>
        </div>
    </atm-grid>
</template>

<style scoped>
    :deep(.link-underline a) {
        @apply underline;
    }
</style>
